import React from "react";
import styles from "../LeftNavigation.module.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as DesignerLogoSVG } from "./designer.svg";

const WorkWithDesigner = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.actionContainer}>
      <a
        href={t("navigation.work_with_designer.linkUrl")}
        target="_blank"
        rel="noreferrer"
      >
        <div className={styles.actionItem}>
          <div className={styles.actionIcon}>
            <DesignerLogoSVG />
          </div>
          <span className={styles.display}>
            {t("navigation.work_with_designer.linkText")}
          </span>
        </div>
      </a>
    </div>
  );
};

export default WorkWithDesigner;
